package com.shadowings.gero.data.lessons.chapter1
import com.shadowings.gero.data.lessons.buildVocabContent
import com.shadowings.gero.data.lessons.buildVocabQuizContent


import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.ImageKeyboardContent
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_empty
import gero.composeapp.generated.resources.exp_content_esempi
import gero.composeapp.generated.resources.exp_content_in_questa_lezione_vedremo_alcuni_nomi_propri_
import gero.composeapp.generated.resources.exp_content_iniziamo_a_leggere_qualche_parola
import gero.composeapp.generated.resources.exp_content_nomi_aten
import gero.composeapp.generated.resources.exp_content_nomi_inpu
import gero.composeapp.generated.resources.exp_content_nomi_ptah
import gero.composeapp.generated.resources.exp_content_nomi_veri
import gero.composeapp.generated.resources.exp_title_introduzione
import gero.composeapp.generated.resources.inpu
import gero.composeapp.generated.resources.iten
import gero.composeapp.generated.resources.ptah
import gero.composeapp.generated.resources.swipe_up

val famousNames = listOf(
    "HA",
    "DEN",
    "INEPU",
    "ITEN",
    "ANY",
    "SOKAR",
    "PTAH",
    "TAURET",
    "ITETI",
    "AKER"
)

fun getFamousNames(words: List<Word>, languageCode: String): List<IExplanation> {
    val intro = listOf(
        ExplanationContent(
            title = Res.string.exp_title_introduzione,
            content = Res.string.exp_content_iniziamo_a_leggere_qualche_parola,
            face = Faces.Happy,
            image = Res.drawable.swipe_up,
            imageSize = 0.35f,
        ),
        ExplanationContent(
            title = Res.string.exp_title_introduzione,
            content = Res.string.exp_content_in_questa_lezione_vedremo_alcuni_nomi_propri_,
            face = Faces.Happy,
        )
    )

    val vocabContent = buildVocabContent(
        lessonTitle = Res.string.exp_title_introduzione,
        lessonIntro = Res.string.exp_content_empty,
        wordIds = famousNames,
        words = words,
        languageCode = languageCode
    )
    val wordSlides =
        vocabContent.drop(1) // Rimuove la singola slide introduttiva di default di buildVocabContent

    val epilogue = listOf(
        ExplanationContent(
            title = Res.string.exp_content_esempi,
            content = Res.string.exp_content_nomi_veri,
            face = Faces.Happy,
        ),
        ExplanationContent(
            title = Res.string.exp_content_esempi,
            content = Res.string.exp_content_nomi_ptah,
            face = Faces.Happy,
            image = Res.drawable.ptah,
            imageSize = 0.75f,
            applyFilter = false,
            fullscreenable = true
        ),
        ExplanationContent(
            title = Res.string.exp_content_esempi,
            content = Res.string.exp_content_nomi_inpu,
            face = Faces.Happy,
            image = Res.drawable.inpu,
            imageSize = 0.75f,
            applyFilter = false,
            fullscreenable = true
        ),
        ExplanationContent(
            title = Res.string.exp_content_esempi,
            content = Res.string.exp_content_nomi_aten,
            face = Faces.Happy,
            image = Res.drawable.iten,
            imageSize = 0.75f,
            applyFilter = false,
            fullscreenable = true
        )
    )

    return intro + wordSlides + epilogue
}

// Photos from the lesson epilogue (image code, word id, caption): the name to transcribe is the
// one highlighted by the red box in each photo.
private val famousNameInscriptions = listOf(
    Triple("ptah", "PTAH", Res.string.exp_content_nomi_ptah),
    Triple("inpu", "INEPU", Res.string.exp_content_nomi_inpu),
    Triple("iten", "ITEN", Res.string.exp_content_nomi_aten),
)

fun getFamousNamesQuiz(words: List<Word>, languageCode: String): List<IQuizContent> {
    val vocabQuizzes = buildVocabQuizContent(getFamousNames(words, languageCode), words, languageCode)
    val inscriptionQuizzes = famousNameInscriptions.mapNotNull { (imageCode, wordId, caption) ->
        val word = words.firstOrNull { it.id == wordId } ?: return@mapNotNull null
        ImageKeyboardContent(
            imageCode = imageCode,
            reading = word.reading.lowercase().map { it.toString() },
            translation = caption
        )
    }
    return (vocabQuizzes + inscriptionQuizzes).shuffled()
}
